module.exports = canvg;